<template lang="pug">
  .field-invoice-number(v-if="$is('invoice-number')")
    p INV{{item.internal_id}}({{item.number}})
    //.document-type
          small {{item.type}}

  .field-emission-date(v-else-if="$is('invoice-emission-date')")
    .field-value Emission date:
    p(v-if="item.emission_date") {{$dateFormat(item.emission_date, $toMomentFormat(configuration.locale.locale_date_format.value))}}

  .field-due-date(v-else-if="$is('invoice-due-date')")
    .field-value Due date:
    p(v-if="item.due_date") {{$dateFormat(item.due_date,$toMomentFormat(configuration.locale.locale_date_format.value))}}

  .field-client-info(v-else-if="$is('invoice-client-info')")
    .field-value Client name:
    router-link(:to="{name:'client', params:{id:item.billing_info.client_id}}")
      | {{item.billing_info.organization_name}}

  .field-tax(v-else-if="$is('invoice-tax')")
    .field-value
      span NET: {{currency}} {{item.subtotal}}
      br
      span TAX: {{currency}} {{item.tax}}

  .field-total(v-else-if="$is('invoice-total')")
    .field-value TOTAL:
      br
      span {{currency}} {{item.document_total}}

  .field-paid-on(v-else-if="$is('invoice-paid-on')")
    p(v-if="item.payed_on") {{$dateFormat(item.payed_on, $toMomentFormat(configuration.locale.locale_date_format.value))}}

  .field-status(v-else-if="$is('invoice-status')")
    .field-value Status:
    p {{item.status}}
  .field-transaction(v-else-if="$is('invoice-transaction')")
    transaction(v-for="transaction in item.transactions", :item="transaction", v-if="transaction.status ==='SUCCESS'",:type="'oneLook'")

</template>
<script type="text/babel">

  import Transaction from "../../../backoffice/Transaction.vue";
  import {mapState} from 'vuex'

  export default {
    components: {Transaction},
    name: "InvoiceFields",
    data() {
      return {}
    },
    methods: {},
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },
    },
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// InvoiceFields.vue?61c402ea